/**
 * data -> objeto = array de itens
 * btnClient -> string = titulo botão area do cliente
 */
import React, { useState, useEffect } from "react";
import './MenuMobile.css'
import Accordion from "../Accordion/Accordion";
import { Link } from "react-router-dom";
import Divider from '../Divider/Divider'
import Btn from '../Btn/Btn'
import socialMedias from '../../lists/socialMedias.json'
import getImage from "../../useFull/getImage";

const MenuMobile = props => {
    const { data, btnClient } = props;
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    return (
        <div>
            <div className={`menu-mobile ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
                <div className="menu-mobile__burger"></div>
            </div>

            <div className={`menu-mobile-overlay ${isOpen ? 'open' : ''}`}>
                <div className='main-container'>
                    <div className="section-container menu-mobile-container">
                        <div className="mg-top-10">
                            {isOpen && data?.map((d, i) => <Accordion
                                key={i}
                                ignoreIconSpace={true}
                                title={d.title}
                                paddingTitle='15px 0'
                                paddingContent='0'
                            >
                                {d.itens?.map((e, ind) => {
                                    return (
                                        <div key={ind}>
                                            <Link to={e.value} className="gray300 dropdown-label" onClick={() => toggleMenu()}>{e.label}</Link>
                                            <Divider height={'1px'}/>
                                        </div>
                                    )
                                })}
                            </Accordion>)}
                        </div>
                        <div className="menu-mobile-end-container">
                        <div className="mg-top-50 d-none"/>
                            <Btn color={'var(--primary300)'} label={btnClient} iconName={'iconbtnclient.png'} className='d-none'/>
                            <div className="menu-mobile-social-icons-container">
                                {socialMedias?.map((d, i) => {
                                    return (
                                        <Link key={i} to={d.link} target="_blank" rel="noopener noreferrer">
                                            <div className={`bg-icon footer-social-icon ${i + 1 !== socialMedias.length && 'mg-r-30'}`} style={{ backgroundImage: `url(${getImage('social', d.iconName)})` }} />
                                        </Link>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MenuMobile
